import styled from "styled-components";

const ProfitCss = styled.div`
  background: linear-gradient(180deg, #255862 0%, #163940 53.12%, #0a171a 100%);
  .wrapper {
    .title {
      transform: translateX(-100%);
      transition: 2s ease;
      font-family: Poppins;
      font-size: 40px;
      font-style: normal;
      font-weight: 300;
      line-height: 60px;
      letter-spacing: 0em;
      text-align: center;
      color: white;
      padding-top: 5rem;
      padding-bottom: 7rem;
      &.fadeIn {
        transform: translateX(0%);
        opacity: 1;
      }
      @media (max-width: 1700px) {
        font-size: 34px;
        padding-top: 4rem;
        padding-bottom: 2rem;
      }
      @media (max-width: 1000px) {
        font-size: 32px;
        padding-top: 2rem;
        padding-bottom: 2rem;
      }
      @media (max-width: 800px) {
        font-size: 28px;
        padding-top: 2rem;
        padding-bottom: 2rem;
      }
      @media (max-width: 600px) {
        font-size: 24px;
        padding: 2rem 1rem 1rem 1rem;
      }

      @media (max-width: 400px) {
        font-size: 22px;
        padding: 2rem 1rem 1rem 1rem;
        line-height: 32px;
      }
    }

    .content {
      display: flex;
      @media (max-width: 800px) {
        display: none;
      }
      margin-bottom: 0;
      padding-bottom: 2rem;
      justify-content: space-between;
      .image {
        flex: 0.3;
        padding-bottom: 3rem;
        width: 30%;
        margin-top: auto;
        margin-bottom: auto;
        img {
          height: 100%;
          object-fit: fill;
          @media (max-width: 1700px) {
            // font-size: 34px;
            // padding-top: 4rem;
            // padding-bottom: 5rem;
            height: 80%;
          }
        }
      }
      .profits_div {
        ::-webkit-scrollbar {
          height: 6px;
          background: #215159;
        }

        /* Track */
        ::-webkit-scrollbar-track {
          box-shadow: inset 0 0 2px grey;
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
          background: #fdcd0b;
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
          background: #fdcd0b;
        }

        flex: 0.7;
        overflow-x: scroll;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 6rem;
        .profits {
          display: flex;
          justify-content: space-around;
          width: 2000px;
          @media (max-width: 1700px) {
            width: 1700px;
          }
          .profit {
            padding: 1rem 5rem 3rem 1rem;
            flex: 0.25;
            @media (max-width: 1700px) {
              padding: 0.5rem 3rem 2rem 0.5rem;
            }
            @media (max-width: 1000px) {
              flex: 0.2;
              padding: 0.5rem 2rem 2rem 0.5rem;
            }
            .profit_title {
              font-family: Poppins;
              font-size: 24px;
              font-style: normal;
              font-weight: 400;
              line-height: 36px;
              letter-spacing: 0em;
              text-align: left;
              color: #ffcb05;
              @media (max-width: 1700px) {
                font-size: 20px;
              }
            }
            .profit_text {
              font-family: Poppins;
              font-size: 22px;
              font-style: normal;
              font-weight: 400;
              line-height: 33px;
              letter-spacing: 0em;
              text-align: left;
              color: white;
              padding-top: 2rem;
              @media (max-width: 1700px) {
                font-size: 16px;
                line-height: 25px;
                padding-top: 1.5rem;
              }
            }
          }
        }
      }
    }
    .content_mobile {
      display: none;
      @media (max-width: 800px) {
        display: flex;
        padding: 1rem 0.5rem 1rem 3rem;
      }
      flex-direction: column;
      .profits {
        display: flex;
        // flex-direction: column;
        justify-content: space-around;
        flex: 0.25;

        .profit {
          flex: 0.5;
          padding-right: 2rem;
          .profit_title {
            padding-top: 1rem;
            font-family: Poppins;
            font-size: 20px;
            font-style: normal;
            font-weight: 400;
            line-height: 36px;
            letter-spacing: 0em;
            text-align: left;
            color: #ffcb05;
          }
          .profit_text {
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0em;
            text-align: left;
            color: white;
            padding-top: 1rem;
            @media (max-width: 400px) {
              font-size: 12px;
              padding-top: 0;
              line-height: 16px;
            }
          }
        }
      }
    }
  }
`;

export default ProfitCss;
